import { render, staticRenderFns } from "./WorkShift.vue?vue&type=template&id=f13437f8&scoped=true"
import script from "./WorkShift.vue?vue&type=script&lang=js"
export * from "./WorkShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13437f8",
  null
  
)

export default component.exports